<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Launcher</h1>

<div>
  <div *ngIf="isWorking">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div *ngIf="env">
    <p><strong>AVEVA ERM v{{env.version}} {{env.name}}</strong></p>
    <p><strong>Id:</strong> {{env.environmentId}} <lib-env-labels [env]="env"></lib-env-labels></p>
    <p><strong>Description:</strong> {{env.description}}</p>
    <p><strong>Region:</strong> {{env.region?.displayName}}</p>
    <p><strong>Status:</strong>&nbsp;<lib-env-status [env]="env"></lib-env-status></p>
  </div>
  <div *ngIf="isInitializing">
    Initializing...
  </div>
  <div *ngIf="isLaunching">
    Launching...
  </div>
  <div *ngIf="isErmUnavailable">
    <p>AVEVA ERM is currently unavailable. Please contact your AVEVA ERM administrator.</p>
  </div>
</div>